<template>
<el-main>
    <div class="btn-upload-group">
        <el-upload ref="upload-schedule" class="btn-upload" :data="{token:token,type:1}" accept=".xlsx" :action="uploadUrl + '/api/ucenter.schedule/upload'" :show-file-list="false" :on-success="uploadFileSuccess" :file-list="fileList">
            <el-button size="small" type="primary">更新值班</el-button>
        </el-upload>
    </div>
    <el-divider></el-divider>
    <el-calendar v-model="currentDate" :range="dateRange">
        <template slot="dateCell" slot-scope="{date, data}">
            <div class="date">    
                <p>
                    {{ data.day.split('-').slice(1).join('-') }}
                </p>
                <p>
                    <span v-for="item in schedule[data.day]" :key="item.id">
                        {{ item.realname.replace("推荐组", '')}}
                    </span>
                </p>
            </div>
        </template>
    </el-calendar>
</el-main>
</template>

<script>
import baseUrl from '@/utils/baseUrl';

export default {
    name: "UserSchedule",
    data() {
        // 获取当月的第一天、最后一天        
        let token = localStorage.getItem('token');
        return {
            currentDate: "",
            token: token,
            uploadUrl: baseUrl,
            dateRange: [],
            schedule: [],
            loading: false,
            fileList: [],
        };
    },
    watch: {
        currentDate: {
            handler: function (val) {
                this.currentDate = val;
                // 判断val是否在dateRange范围内
                if (val < this.dateRange[0] || val > this.dateRange[1]) {
                    // 获取val月的第一天、最后一天
                    let date = new Date(val);
                    let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
                    let lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
                    this.dateRange = [firstDay, lastDay];
                    this.getSchedule();
                }
            },
            deep: true,
            immediate: true
        }
    },
    created () {
        this.currentDate = new Date();
        let firstDay = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), 1);
        let lastDay = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() + 1, 0);
        this.dateRange = [firstDay, lastDay];
    },
    methods: {
        uploadFileSuccess(res, file, flieLsit) {
            if (res.code == 200) {
                this.$message({
                    type: 'success',
                    message: res.msg
                });
            }
        },
        // 获取排班数据
        getSchedule() {
            this.loading = true;
            // 获取currentDate月份
            let date = new Date(this.currentDate);
            let month = date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0');

            this.$post('/api/ucenter.schedule/index', {
                token: this.token,
                month: month
            }).then(res => {
                this.loading = false;
                if (res.code == 200) {
                    // 如果是空数组，说明没有排班数据
                    if (res.data.length == 0) {
                        this.$message({
                            type: 'info',
                            message: '暂无排班数据'
                        });
                    } else {
                        this.schedule = res.data;
                    }
                } else {
                    this.$message.error(res.msg);
                }
            }).catch(err => {
                this.loading = false;
                this.$message.error('网络错误');
            });
        }
    }
}
</script>

<style lang="less">
.btn-upload-group {
    display: flex;
    margin-bottom: 20px;

    .btn-upload {
        height: 32px;
    }

    .el-upload--text {
        background-color: #fff;
        border: none;
        border-radius: 6px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        width: 120px !important;
        height: 35px !important;
        font-size: 12px;
    }
}
</style>
